import { render, staticRenderFns } from "./appManageConfig.vue?vue&type=template&id=c2598064&scoped=true"
import script from "./appManageConfig.vue?vue&type=script&lang=js"
export * from "./appManageConfig.vue?vue&type=script&lang=js"
import style0 from "./appManageConfig.vue?vue&type=style&index=0&id=c2598064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2598064",
  null
  
)

export default component.exports